import { Redirect, useLocation } from "react-router-dom";
import { useRecoilValue } from "recoil";

import { AllstarUser } from "../../State";

const ProfileRedirect = () => {
  const allstarUser = useRecoilValue(AllstarUser);
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const userParam = searchParams.get("user");
  const username =
    allstarUser.user?.profile?.username || allstarUser.user?.username;
  const userId = allstarUser.user?._id;

  if (userParam) {
    searchParams.delete("user");
    const remainingSearch = searchParams.toString();
    const searchString = remainingSearch ? `?${remainingSearch}` : "";
    return <Redirect to={`/u/${userParam}${searchString}`} />;
  }

  if (!allstarUser.loggedIn) return <Redirect to="/login" />;

  const userIdentifier = username || userId;

  return userIdentifier ? (
    <Redirect to={`/u/${userIdentifier}${location.search}`} />
  ) : (
    <Redirect to="/login" />
  );
};

export { ProfileRedirect };
